import React from 'react';
import { withRouter } from 'react-router-dom';
import { compose, bindActionCreators } from 'redux';
import { connect } from 'react-redux';

import { grey } from '@material-ui/core/colors';
import Button from '@material-ui/core/Button';
import Typography from '@material-ui/core/Typography';
import withStyles from '@material-ui/core/styles/withStyles';
import WarningIcon from '@material-ui/icons/Warning';

import { sendError } from '../../../state/order/actions';


const styles = theme => ({
  root: {
    height: '100%',
    display: 'flex',
    justifyContent: 'center',
    alignItems: 'center',
    flexDirection: 'column',
  },
  icon: {
    color: grey[400],
    fontSize: 78,
    marginBottom: 10,
  },
  text: {
    marginBottom: 10,
  },
});

class ErrorBoundary extends React.Component {
  state = {
    hasError: false,
  }

  static getDerivedStateFromError(error) {
    return { hasError: true };
  }

  componentDidCatch(error, errorInfo) {
    this.props.sendError(error.stack);
    console.error(error, errorInfo);
  }

  render() {
    if (this.state.hasError) {
      const { classes } = this.props;

      return (
        <div className={classes.root}>
          <WarningIcon fontSize="large" className={classes.icon} />
          <Typography variant="caption" className={classes.text}>Ocorreu algum erro inesperado</Typography>
          <Button color="primary" onClick={this.props.history.goBack}>Voltar</Button>
        </div>
      );
    }

    return this.props.children;
  }
}

const mapStateToProps = (state) => ({});
const mapDispatchToProps = (dispatch) => bindActionCreators(
  {
    sendError,
  }, dispatch);
export default compose(withRouter, withStyles(styles), connect(mapStateToProps, mapDispatchToProps))(ErrorBoundary);
